// unification of common form field names, which are used throughout the app
// newly applied to all new/refactored MUI pages
// there will be more added in future

export const COMMON_FORM_FIELD_NAMES = {
	firstName: 'firstName',
	surname: 'surname',
	businessName: 'businessName',
	businessIn: 'businessIn',
	birthDate: 'birthDate',
	personIn: 'personIn',
	municipality: 'municipality',
	street: 'street',
	streetNo: 'streetNo',
	zipCode: 'zipCode',
	phoneNumber: 'phoneNumber',
	wave: 'wave',
	superior: 'superior',
	subordinate: 'subordinate',
	region: 'region',
	policyNumber: 'policyNumber',
	proposalNumber: 'proposalNumber',
	policyStatus: 'policyStatus',
	controlStatus: 'controlStatus',
	client: 'client',
	documentType: 'documentType',
	policyHolder: 'policyHolder',
	product: 'product',
	productDomain: 'productDomain',
	birthYearFrom: 'birthYearFrom',
	birthYearTo: 'birthYearTo',
	contactType: 'contactType',
	note: 'note',
	sellerIn: 'sellerIn',
	ppz: 'ppz',
	seller: 'seller',
	channel: 'channel',
	agency: 'agency',
	manager: 'manager',
	email: 'email',
	title: 'title',
	policyHolderFirstName: 'policyHolderFirstName',
	policyHolderSurname: 'policyHolderSurname',
	policyHolderBusinessName: 'policyHolderBusinessName',
	taskType: 'taskType',
	taskSubTypeId: 'taskSubTypeId',
	login: 'login',
	fileUpload: 'fileUpload',
	campaignName: 'campaignName',
	campaignType: 'campaignType',
	startDate: 'startDate',
	endDate: 'endDate',
	communicationName: 'communicationName',
	guarantors: 'guarantors',
	noteFullName: 'noteFullName',
	noteDateCreated: 'noteDateCreated',
	noteContent: 'noteContent',
	dateFrom: 'dateFrom',
	dateTo: 'dateTo',
	centralConsent: 'centralConsent',
};
